// extracted by mini-css-extract-plugin
export default {"formContainer":"InviteToMobileAppModal_formContainer__6Tx9d"};